export default __webpack_public_path__ + "static/media/onboarding-graphic-left.b2b5b6d6.svg";